<route lang="json">
{ "name": "shop-cart" }
</route>

<template>
  <div class="cart-page">
    <RepBanner />

    <div v-if="cart.object.items.length === 0" class="empty flex-column gap-xl">
      <h3>Your shopping bag is empty.</h3>

      <RouterLink id="shopping-button" :to="{ name: 'shop' }">
        <Button class="pink"> Start Shopping </Button>
      </RouterLink>
    </div>
    <div v-else class="cart-items-cont flex-row pa-p1">
      <CartItems />
      <div class="summary-column flex-column">
        <CartTotals />
        <div class="checkout flex-row flex-center">
          <router-link :to="{ name: 'shop-checkout' }">
            <Button class="pink">Checkout</Button>
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="cart.count > 0" class="bottom-buttons">
      <router-link id="shopping-button" to="/shop/">
        <Button class="grey"> Continue Shopping </Button>
      </router-link>
      <Button class="grey" @click="cart.empty()"> Empty Bag </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import RepBanner from "@/components/rep/RepBanner.vue";
import CartItems from "@/components/shop/CartItems.vue";
import CartTotals from "@/components/shop/CartTotals.vue";
import { useCartStore } from "@/stores/cart";
import { useJoinStore } from "@/stores/join";
import { useShopStore } from "@/stores/shop";
import { useHead } from "@unhead/vue";
import Button from "primevue/button";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";

const shop = useShopStore();
const cart = useCartStore();
const join = useJoinStore();
const router = useRouter();

useHead({
  title: "My Shopping Bag",
});

onBeforeMount(() => {
  if ((join.kit?.jewelry_count || 0) > 0) {
    router.push({ name: "shop" });
  } else if (join.kit?.id) {
    router.push({ name: "opportunities-signup" });
  }
});
</script>

<style scoped>
.cart-page {
  margin: var(--1XL) auto;
}
.cart-items-cont {
  margin-top: var(--XL);
  gap: var(--md);
}
.p-button {
  padding: var(--2XS, 8px);
  justify-content: left;
}
.p-button.pink,
.p-button.grey {
  padding: var(--2XS, 8px) var(--XS, 16px);
}

#app .p-button-text:hover {
  color: var(--Black, #000);
  font-weight: 400;
}

.checkout {
  margin-top: var(--Sm);
}

.empty {
  text-align: center;
  min-height: 395px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--Black, #000);
  text-align: center;
}
.empty h3 {
  margin: 0;

  /* Name of Piece */
  font-family: Indivisible;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}
.empty * {
  flex: 0 0 auto;
}
.bottom-buttons {
  display: flex;
  justify-content: center;
  gap: 54px;
  margin-top: 64px;
}

.summary-column {
  position: sticky;
  top: 70px;
  width: 260px;
  height: auto;
  place-self: flex-start;
}

@media (max-width: 800px) {
  .summary-column {
    position: fixed;
    bottom: 0;
    top: auto;
    background: white;
    left: 0;
    right: 0;
    padding: 5px;
    z-index: 1;
  }
}

@media (max-width: 1152px) {
  .cart-items-cont {
    padding: 0 var(--XS, 16px);
  }
}

@media (max-width: 930px) and (min-width: 801px) {
  .summary-column {
    width: 200px;
  }
}

@media only screen and (max-width: 800px) {
  .flex-row,
  #app .flex-row {
    display: inline-grid;
    width: 100%;
  }
  .cart-items-cont {
    margin: 0;
    /* padding: 0 var(--Sm, 24px); */
    padding: 0;
  }
  .summary-column {
    position: static;
  }
  .summary-column > * {
    width: 100%;
  }

  .summary-column {
    width: 80%;
    margin: 0 auto;
  }

  .cart-page {
    margin: var(--1XL, 64px) auto var(--Sm, 24px);
  }
}

@media screen and (max-width: 600px) {
  .summary-column {
    width: 100%;
  }
}
</style>
